import { Icon } from "./Icons";

type Props = {
  open: boolean;
  onClose: () => void;
  // Filename of the .modl file the user just clicked. Null when no download
  // has happened yet (overlay shouldn't be open in that case).
  filename: string | null;
  // URL of the .modl file. Null when no download is in flight; otherwise
  // used to wire the "Download again" link.
  url: string | null;
};

// Post-download confirmation overlay. Triggered explicitly by the host
// app after a download click; not auto-shown.
export function PostDownloadOverlay({ open, onClose, filename, url }: Props) {
  if (!open) return null;
  const display = filename ?? "coprocessor-<version>-<platform>.modl";
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(28,26,22,.45)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 8,
          maxWidth: 520,
          width: "100%",
          padding: "32px 36px 28px",
          boxShadow: "0 20px 60px rgba(0,0,0,.25)",
          position: "relative",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 14,
            right: 14,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "var(--ink-4)",
          }}
        >
          <Icon.X />
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <Icon.Check style={{ color: "var(--ok)" }} />
          <div style={{ fontSize: 20, fontWeight: 500, letterSpacing: "-0.01em" }}>
            Your download has started.
          </div>
        </div>
        <p style={{ fontSize: 14, color: "var(--ink-2)", lineHeight: 1.55, marginTop: 10 }}>
          Next: open your Ignition gateway and install the module. If you want help sizing a
          workload, send us your tag count, cadence, payload shape, and current script logic.
        </p>
        <ol
          style={{
            fontSize: 14,
            color: "var(--ink-2)",
            lineHeight: 1.6,
            paddingLeft: 20,
            marginTop: 10,
          }}
        >
          <li>
            Go to{" "}
            <span className="mono" style={{ fontSize: 13 }}>
              Platform &gt; Modules
            </span>
          </li>
          <li>
            Click{" "}
            <span className="mono" style={{ fontSize: 13 }}>
              Install or Upgrade a Module
            </span>
          </li>
          <li>
            Upload{" "}
            <span className="mono" style={{ fontSize: 13 }}>
              {display}
            </span>
          </li>
        </ol>
        <div className="mono" style={{ fontSize: 11, color: "var(--ink-3)", marginTop: 16 }}>
          Didn't start?{" "}
          <a
            href={url ?? "#"}
            download={filename ?? undefined}
            className="lnk"
          >
            Download again
          </a>
        </div>
      </div>
    </div>
  );
}
